import { useEffect, useState } from 'react'

export type SelectOption = {
  value: string | number
  label: string
  subLabel?: string
}

export const useSelect = (onSelect?: (value: string) => void, defaultOption?: SelectOption | null) => {
  const [isSelectOpen, setIsSelectOpen] = useState(false)
  const [chosenOption, setChosenOption] = useState(defaultOption || null)

  useEffect(() => {
    if (!chosenOption && defaultOption) {
      setChosenOption(defaultOption)
    }
  }, [defaultOption])

  const toggleSelect = () => setIsSelectOpen((isOpen) => !isOpen)
  const closeSelect = () => setIsSelectOpen(false)
  const clearOption = () => {
    onSelect && onSelect('')
    setIsSelectOpen(false)
    setChosenOption(null)
  }
  const chooseOption = (option: SelectOption) => {
    onSelect && onSelect(String(option.value))
    setChosenOption(option)
    setIsSelectOpen(false)
  }

  return {
    isSelectOpen,
    chosenOption,
    toggleSelect,
    closeSelect,
    clearOption,
    chooseOption,
  }
}
